function isValidInteger(value: string): boolean {

    const parsedValue = Number(value);
    return !isNaN(parsedValue) && Number.isInteger(parsedValue);
}

export default isValidInteger
